import SubFilterItem from "./SubFilterItem";
import { useEffect, useState, useRef } from "react";
import { slugify } from "../../../../utils/slugifyString";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const SubFilters = ({
  filter,
  filtersState,
  filterName,
  setFiltersState,
  itemDiv,
  filters,
  setSelectedInstitution,
  filtersKeys,
}) => {
  const [currentFilterKey, setCurrentFilterKey] = useState("");

  useEffect(() => {
    filtersKeys.forEach((key) => {
      if (filter?.slug === filters[key].slug) {
        setCurrentFilterKey(key);
      }
    });
  }, []);


  let subfilterItems = [];
  filtersKeys.forEach((key) => {
    if (filters[key].isSubFilter === true) {
      subfilterItems = filters[key].values.map((item) => {
        if (item.parentFilter === filter?.slug) {
          if (
            Object.keys(filtersState).length &&
            filtersState[item.parentKey]?.indexOf(item.parentFilter) !== -1
          ) {
            // console.log("true", item.parentKey);
            // console.log(item);
            // console.log("state", filtersState);
            // console.log(
            //   filtersState[item.parentKey]?.indexOf(item.parentFilter) !== -1
            // );
          } else {
            // console.log("true", item);
          }
          return (
            <SubFilterItem
              key={item.name}
              item={item}
              setFiltersState={setFiltersState}
              filterKey={key}
              setSelectedInstitution={setSelectedInstitution}
              filtersState={filtersState}
              isDisplayed={
                Object.keys(filtersState).length &&
                filtersState[item.parentKey]?.indexOf(item.parentFilter) !== -1
                  ? true
                  : false
              }
            />
          );
        }
      });
      // }
    }
  });

  subfilterItems = subfilterItems.filter((item) => item);

  return (
    <>
      {subfilterItems?.length > 0 && (
        <div className="subfilter-wrapper">
          {/* <OverlayScrollbarsComponent
        className="overlay-scrollbar os-theme-dark"
        options={{
          overflowBehavior: {
            x: "hidden",
            y: "scroll",
          },
        }}
      > */}
          <div className="subfilters-wrapper">{subfilterItems}</div>
          {/* </OverlayScrollbarsComponent> */}
        </div>
      )}
    </>
  );
};

export default SubFilters;
